import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { convertSqlTimestampToDate } from "utils/UtilityFuncs";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: 20,
  },
  boldText: {
    fontWeight: "bold",
  },
  topHeader: {
    height: 75,
  },
  shippingDescription: {
    marginVertical: 5,
  },
  headingMain: { fontSize: 20, fontWeight: "bold" },
  headingSecond: { fontSize: 12, fontWeight: "bold" },
  headingThird: { fontSize: 15, fontWeight: "bold" },
  textbody: { fontSize: 10 },
  mainContainer: {
    marginBottom: "20px",
    flexDirection: "column",
    border: "1px solid grey",
  },
  prodTitle: {
    width: "100%",
    textAlign: "left",
    padding: "5px 10px",

    borderBottom: "1px solid grey",
    fontSize: "14px",
  },
  prodMain: {
    width: "100%",
    flexDirection: "row",
  },
  prodContent: {
    flexGrow: 1,
  },
  prodSizes: {
    padding: "5px",
    width: "150px",
    borderLeft: "1px solid grey",
  },
  prodInfoRow: {
    display: "flex",
    flexDirection: "row",
    fontSize: "10px",
  },
  prodCol: {
    display: "flex",
    flexDirection: "row",
    width: "50%",
  },
  prodKey: {
    padding: "3px 5px",
    width: "40%",
    borderRight: "1px solid grey",
    borderBottom: "1px solid grey",
  },
  prodVal: {
    padding: "3px 5px",
    width: "60%",
    borderBottom: "1px solid grey",
  },
  prodComments: {
    padding: "5px 10px",
    fontSize: "12px",
    borderTop: "1px solid grey",
  },
  prodSubHeading: {
    fontSize: "12px",
  },
  prodTxt: {
    fontSize: "10px",
  },
  borderRight: { borderRight: "1px solid grey" },
  colWithLong: {
    width: "200px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWith: {
    width: "60px",
    marginTop: 5,
    marginBottom: 3,
    marginHorizontal: 5,
  },
  colWithSm: {
    width: "30px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWithXs: {
    width: "10px",
    marginTop: 5,
    marginBottom: 3,
  },
});

// Create Document Component
export const LossRunReportPdf = ({ reportData }) => {
  const getCurrentDate = () => {
    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    return `${date}-${month}-${year}`;
  };

  const getCurrentTime = () => {
    const currentDate = new Date();
    let hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const amPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${amPm}`;
  };

  return (
    <Document title={`Loss Run Report - L-${reportData.lossId}`}>
      <Page size="LETTER" style={styles.page}>
        {/* Header */}
        <View
          style={{
            marginBottom: 20,
            borderBottom: "1px solid black",
            paddingBottom: 10,
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text style={[styles.boldText, { fontSize: 18 }]}>
              Loss Run Report
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 5,
            }}
          >
            <Text style={[styles.boldText, { fontSize: 14 }]}></Text>
            <Text style={{ fontSize: 13 }}>L-{reportData?.lossId}</Text>
          </View>
          <View>
            <Text style={{ fontSize: 13 }}>Print Date: {getCurrentDate()}</Text>
            <Text style={{ fontSize: 13 }}>Print Time: {getCurrentTime()}</Text>
          </View>
        </View>

        {/* Report Details */}
        <View style={{ marginTop: 10 }}>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={[styles.boldText, { fontSize: 12, width: "25%" }]}>
              Responsible Employee:
            </Text>
            <Text style={{ fontSize: 12, width: "75%" }}>
              {reportData.byEmployee}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={[styles.boldText, { fontSize: 12, width: "25%" }]}>
              Department:
            </Text>
            <Text style={{ fontSize: 12, width: "75%" }}>
              {reportData.department}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={[styles.boldText, { fontSize: 12, width: "25%" }]}>
              Amount:
            </Text>
            <Text style={{ fontSize: 12, width: "75%" }}>
              {reportData.amount.toLocaleString()}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={[styles.boldText, { fontSize: 12, width: "25%" }]}>
              Created At:
            </Text>
            <Text style={{ fontSize: 12, width: "75%" }}>
              {convertSqlTimestampToDate(reportData.createdAt, true)}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={[styles.boldText, { fontSize: 12, width: "25%" }]}>
              Last Updated:
            </Text>
            <Text style={{ fontSize: 12, width: "75%" }}>
              {convertSqlTimestampToDate(reportData.updatedAt, true)}
            </Text>
          </View>
        </View>

        <View style={{ marginTop: 10, paddingTop: 10 }}>
          <Text style={[styles.boldText, { fontSize: 16 }]}>Description:</Text>
          <View
            style={{
              marginTop: 5,
              borderTop: "1px solid black",
              paddingTop: 10,
            }}
          >
            <Text style={{ fontSize: 12 }}>{reportData.description}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};
